import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import CookieBanner from "@/components/CookieBanner";
import WelcomePopup from "@/components/WelcomePopup";

export default function Layout({ children, welcome = false }) {
  return (
    <div id="top" className="min-h-screen bg-cream text-charred">
      <Navbar />
      <main>{children}</main>
      <Footer />
      <FloatingButtons />
      <CookieBanner />
      {welcome && <WelcomePopup />}
    </div>
  );
}
